import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const KeyResultName = styled.div`
  font-size: 20px;
  font-weight: 300;
  line-height: 60px;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin: 15px 0;
  ${media.phone`
    font-size: 0.75rem;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.08;
    letter-spacing: normal;
    text-align: center;
    margin: 5px 0;
  `}
`;

export const ProgressTargetContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const ProgressValueContainer = styled.div`
  flex: 1 1;
  max-width: 125px;
`;
export const TargetValueContainer = styled.div`
  flex: 1 1;
  max-width: 125px;
  text-align: right;
  margin-left: auto;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
`;

export const SliderContainer = styled.div`
  width: 100%;
  margin-bottom: 37px;
  margin-top: 10px;
  ${media.phone`
    margin-bottom: 20px;
  `}
`;

export const CommentContainer = styled.div`
  width: 100%;
`;
